import React from "react";

import { LayersControl, TileLayer, GeoJSON, LayerGroup } from 'react-leaflet';
const { Overlay, BaseLayer } = LayersControl;

import PropTypes from "prop-types";

const MapLayersControl = ({ geoToolboxUrl, urlLayers, geoJsonLayers }) => {
    const getOnEachFeatureFunctionForTooltipProperties = (tooltipProperties) => {
        if (tooltipProperties && tooltipProperties.length > 0)
            return (feature, layer) => {
                let content = tooltipProperties.map(x => {
                    if (feature.properties && feature.properties[x])
                        return `${feature.properties[x]}<br />`;
                });

                layer.bindTooltip(content.reduce((a, b) => a + b));
            };
    };

    return (<LayersControl position="topleft">
        {urlLayers.map(x =>
            <Overlay name={x.name} key={x.name} checked={x.checked}>
                <TileLayer
                    key={x.name}
                    attribution={x.attribution}
                    url={geoToolboxUrl + x.url}
                    tms={x.tms}
                    crs={x.crs}
                />
            </Overlay>)}
        {geoJsonLayers.map(x =>
            <Overlay name={x.name} key={x.name} checked={x.checked}>
                <LayerGroup>
                    <GeoJSON
                        key={x.key}
                        data={x.geoJson}
                        style={x.style}
                        onEachFeature={getOnEachFeatureFunctionForTooltipProperties(x.tooltipProperties)} />
                </LayerGroup>
            </Overlay>)}
    </LayersControl>);
};

MapLayersControl.propTypes = {
    geoToolboxUrl: PropTypes.string,
    urlLayers: PropTypes.array,
    geoJsonLayers: PropTypes.array
};

export default MapLayersControl;